/**
 * Scope Badge
 *
 * Icon badge indicating section ownership scope (user/org/public)
 */

import React from 'react';
import Logo from '@components/Icons/Logo';
import { useBrandLanguage } from '@context/brand-language/context';
import { AccountCircle, Groups } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';

export type SectionScope = 'user' | 'org' | 'public';

interface ScopeBadgeProps {
  /** Section ownership scope */
  scope: SectionScope;
}

export const ScopeBadge: React.FC<ScopeBadgeProps> = ({ scope }) => {
  const { brandLanguage } = useBrandLanguage();

  switch (scope) {
    case 'user':
      return (
        <Tooltip title="My Section" placement="top" arrow>
          <AccountCircle sx={{ fontSize: 20, color: 'text.secondary' }} />
        </Tooltip>
      );
    case 'org':
      return (
        <Tooltip title="Organization Section" placement="top" arrow>
          <Groups sx={{ fontSize: 20, color: 'text.secondary' }} />
        </Tooltip>
      );
    case 'public':
      return (
        <Tooltip title={`${brandLanguage.brandName} Section`} placement="top" arrow>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Logo size={18} />
          </Box>
        </Tooltip>
      );
    default:
      return null;
  }
};

